import { locatorServiceAPI } from 'shared/services';

import {
  NavigationAutos,
  CardNumber,
  GetObuCardsForm,
  NavigationHistory,
  GetLocationsHistoryForm
} from '../types';

export const navigationAPI = {
  getAutos: () => locatorServiceAPI.get<{ autoObuPairs: NavigationAutos; }>('navigation/autoObuPairs'),
  getLocationsHistory: (form: GetLocationsHistoryForm) => locatorServiceAPI.post<NavigationHistory>('navigation/LocationsHistory', form),
  getObuCards: (form: GetObuCardsForm) => locatorServiceAPI.post<{ cards: CardNumber[] }>('navigation/getClientObuAutoNumberCards', form)
};
